<template>
	<transition name="dashboard" mode="out-in">
		<div class="container">
			<div class="dashboard">
				<stream-stats/>
				<offline-streams/>
			</div>
			<archive/>
			<gist/>
		</div>
	</transition>
</template>
<script>
	import StreamStats                  from "../components/StreamStats";
	import offlineStreams               from "./OfflineStreams";
	import { performRequest }           from "../script/ws/wsclient";
	import { mapMutations, mapGetters } from "vuex";
	import Archive                      from "./Archive";
	import Gist                         from "./Gist";

	export default {
		name:       "Dashboard",
		data() {
			return {
				command:      {},
				arr:          [],
				autocomplete: []
			};
		},
		components: {
			Gist,
			Archive,
			StreamStats,
			offlineStreams
		},
		mounted() {
			this.getStraemStatus();
			performRequest(
				{
					section: "iptvlog",
					name:    "getUserList"
				},
				{
					// dateFrom: Date.parse(`${new Date()}`) / 1000 - 3600,
					// dateTo:   Date.parse(`${new Date()}`) / 1000,
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						a.data.forEach(el => {
							this.autocomplete.push(el.uid);

						});
						this.setAutocomplete(this.autocomplete);
					} else {
						console.log("ошибка при получении ответа!");
					}

				}
			);
		},
		methods:    {
			...mapMutations(["setAutocomplete", "setStreams"]),
			getStraemStatus() {
				this.command.section = "iptvlog";
				this.command.name    = "getStreamStatus";
				performRequest(this.command, {operator: this.getViewUser}, a => {
					this.setStreams(a.data);
				});
			}
		},
		computed:   {
			...mapGetters(["getViewUser"])
		}
	};
</script>
<style scoped lang="scss">
	.container {
		position: absolute;
		display: flex;
		flex-direction: column;
		margin-top: 3.5rem;
		width: 100%;
		left: 50%;
		transform: translateX(-50%);
		
		.dashboard {
			position: relative;
			margin: auto;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: center;
		}
	}
	@media (min-width: 1200px) {
		.dashboard {
			width: 98%;
		}
	}
	@media (max-width: 620px) {
		.container {
			margin-top: 8rem;
		}
	}
	.dashboard-enter-active {
		transition: all 0.3s ease;
	}
	.dashboard-leave-active {
		transition: all 0.3s ease;
	}
	.dashboard-enter, .dashboard-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue